import styled from '@emotion/styled';
import Image from 'next/image';
import { NextRouter, useRouter } from 'next/router';
import React from 'react';
import logo from './../../../../public/assets/images/logo.png';

const Button = styled.button<{ buttonWidth: number; buttonHeight: number }>`
  position: relative;
  width: ${props => `${props.buttonWidth}px`};
  height: ${props => `${props.buttonHeight}px`};
  justify-self: left;

  @media (max-width: 405px) {
    width: 115px;
    height: 20px;
  }
`;

interface Props {
  width?: number;
  height?: number;
  onClick?: () => void;
}

/**
 *  쏠카로고 컴포넌트
 * @param {number} width 로고 너비 (default: 144)
 * @param {number} height 로고 높이 (default: 23)
 *  */
function SolecarLogo({ width = 144, height = 23, onClick }: Props): JSX.Element {
  const router: NextRouter = useRouter();
  return (
    <Button
      buttonWidth={width}
      buttonHeight={height}
      onClick={() => {
        onClick && onClick();
        router.push('/');
      }}
    >
      <Image src={logo} alt='쏠카 로고 이미지' sizes='auto' fill priority />
    </Button>
  );
}

export default SolecarLogo;
